const KYC_TABLE_HEADERS = [
  {
    name: 'Merchant',
    column: 'merchant_name'
  },
  {
    name: 'Contact',
    column: 'merchant_contact'
  },
  {
    name: 'KYC Type',
    column: 'kyc_type_label'
  },
  {
    name: 'Documents',
    column: 'document_progress'
  },
  {
    name: 'Status',
    column: 'status'
  },
  {
    name: 'Last Updated',
    column: 'updated_at',
    filter: 'date'
  }
];

const KYC_STATUSES = [
  {
    label: 'All Statuses',
    value: ''
  },
  {
    label: 'Pending',
    value: 'PENDING'
  },
  {
    label: 'Approved',
    value: 'APPROVED'
  },
  {
    label: 'Declined',
    value: 'DECLINED'
  },
  {
    label: 'In Progress',
    value: 'IN_PROGRESS'
  },
  {
    label: 'Skipped',
    value: 'SKIPPED'
  }
];

const KYC_TYPES = [
  {
    label: 'All Types',
    value: ''
  },
  {
    label: 'Freelancers',
    value: 'FREELANCER'
  },
  {
    label: 'Corporate Financial Institution',
    value: 'CORPORATE_FINANCIAL_INSTITUTION'
  },
  {
    label: 'Corporate Non-Financial Institution',
    value: 'CORPORATE_NON_FINANCIAL_INSTITUTION'
  }
];

const KYC_INPUT_TYPE = {
  FILE: 'FILE',
  TEXT: 'TEXT',
  URL: 'URL'
};

const KYC_DOCUMENT_REQUIREMENTS = {
  FREELANCER: [
    {
      id: 'MEANS_OF_IDENTIFICATION',
      label: 'Means of Identification',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'BVN',
      label: 'BVN',
      inputType: KYC_INPUT_TYPE.TEXT
    },
    {
      id: 'PROOF_OF_ADDRESS',
      label: 'Proof of Address',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'FREELANCE_PLATFORM_LINK',
      label: 'Link to Freelance Platform',
      inputType: KYC_INPUT_TYPE.URL
    },
    {
      id: 'FREELANCE_PLATFORM_EVIDENCE',
      label: 'Evidence (Profile Page) of Freelance Platform',
      inputType: KYC_INPUT_TYPE.FILE
    }
  ],
  CORPORATE_FINANCIAL_INSTITUTION: [
    {
      id: 'CERTIFICATE_OF_INCORPORATION',
      label: 'Certificate of Incorporation',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION',
      label: 'Memorandum & Articles of Association',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'PARTICULARS_OF_DIRECTORS',
      label: 'Particulars of Directors, BVN inclusive',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'CERTIFIED_LIST_OF_SHAREHOLDERS',
      label: 'Certified List/Chart of Shareholders (5% and above)',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'MEANS_OF_IDENTIFICATION_OF_ULTIMATE_BENEFICIAL_OWNERS',
      label: 'Means of Identification of Ultimate Beneficial Owners',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'VALID_OPERATING_LICENCES',
      label: 'Valid Operating Licences',
      isMandatory: false,
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'PROOF_OF_BUSINESS_OPERATING_ADDRESS',
      label: 'Proof of Business Operating Address',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'SCUML',
      label: 'SCUML Certificate (If required)',
      isMandatory: false,
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'AML/CFT_POLICY',
      label: 'AML/CFT Policy',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'DUE_DILIGENCE_QUESTIONNAIRE',
      label: 'Due Diligence Questionnaire',
      inputType: KYC_INPUT_TYPE.URL
    }
  ],
  CORPORATE_NON_FINANCIAL_INSTITUTION: [
    {
      id: 'CERTIFICATE_OF_INCORPORATION',
      label: 'Certificate of Incorporation',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION',
      label: 'Memorandum & Articles of Association',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'PARTICULARS_OF_DIRECTORS',
      label: 'Particulars of Directors',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'CERTIFIED_LIST_OF_SHAREHOLDERS',
      label: 'Certified List/Chart of Shareholders (5% and above)',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'MEANS_OF_IDENTIFICATION_OF_ULTIMATE_BENEFICIAL_OWNERS',
      label: 'Means of Identification of Ultimate Beneficial Owners',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'VALID_OPERATING_LICENCES',
      label: 'Valid Operating Licences',
      isMandatory: false,
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'PROOF_OF_BUSINESS_OPERATING_ADDRESS',
      label: 'Proof of Business Operating Address',
      inputType: KYC_INPUT_TYPE.FILE
    },
    {
      id: 'SCUML',
      label: 'SCUML Certificate',
      isMandatory: false,
      inputType: KYC_INPUT_TYPE.FILE
    }
  ]
};

export { KYC_TABLE_HEADERS, KYC_STATUSES, KYC_TYPES, KYC_DOCUMENT_REQUIREMENTS, KYC_INPUT_TYPE };
